import './NoSelectedChat.css';

const NoSelectedChat = () => {
    return (
        <section className="chatarea">
            <div className="chatarea_container_no-selected">
                <h4 id="no-selected-msg">Select a chat or start a new conversation</h4>
            </div>
        </section>
    )
}

export default NoSelectedChat;